"use client";
import { followAPI } from '@/services/followListService';
import React, { useState, useEffect } from 'react';
import { showSuccess } from '@/utils/toast';

const FollowUnFollowButton = ({id, isFollowingData}) => {
    const [isFollowing, setIsFollowing] = useState(isFollowingData);


    const handleFollowUnfollow = async () => {
        try {
            const response = await followAPI({ authorId: id });
            if(response.status === 200){
              showSuccess(response.message);
              setIsFollowing(response.data.is_following);
            }
          } catch (error) {
          }
    }

    useEffect(() => {
        setIsFollowing(isFollowingData);
    }, [isFollowingData]);
    
    return (
        <>
            {isFollowing ? (
                <button className="btn-unfollow-ap" onClick={handleFollowUnfollow}>Unfollow</button>
            ) : (
                <button className="btn-unfollow-ap" onClick={handleFollowUnfollow}>Follow</button>
            )}
        </>
    );
};

export default FollowUnFollowButton;